import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import NavigationBar from "../../components/Heritage/NavigationBar";
import { Link } from "react-router-dom";
import IndianFoodFilter from "./IndianFoodFilter";

const ancientFoodData = {
  North: [
    {
      name: "Butter chicken",
      image:
        "https://res.cloudinary.com/enchanting/q_70,f_auto,w_585,h_330,c_fill,g_face/enchanting-web/2023/09/Enchanting-Travels-India-Tours-Butter-chicken-curry-with-basmati-rice-and-limes.jpg",
      description: "Butter chicken – a popular creamy chicken dish",
    },
    {
      name: "Daal-Baati",
      image:
        "https://res.cloudinary.com/enchanting/q_70,f_auto,w_585,h_330,c_fill,g_face/enchanting-web/2023/09/Enchanting-Travels-India-Tours-Daal-Baati-Churma-is-a-popular-Healthy-food-from-Rajasthan-India.jpg",
      description: "Daal-Baati – a popular dish in Rajasthan",
    },
    {
      name: "Aloo paratha",
      image:
        "https://res.cloudinary.com/enchanting/q_70,f_auto,w_585,h_330,c_fill,g_face/enchanting-web/2023/09/Enchanting-Travels-India-Tours-North-Indian-Potato-stuffed-bread-served-in-a-basket-with-raita.jpg",
      description: "Aloo paratha – Indian bread stuffed with potato",
    },
    // {
    //   name: "",
    //   image: "",
    //   description: "",
    // },
  ],
  South: [
    {
      name: "Kambu Koozh",
      image: "https://i.ytimg.com/vi/GO5INOqJqZI/maxresdefault.jpg",
      description: "Fermented pearl millet porridge, ancient Tamil staple.",
    },
    {
      name: "Ragi Mudde",
      image:
        "https://www.sharmispassions.com/wp-content/uploads/2019/06/raggi-mudde-step17.jpg",
      description: "Finger millet balls rich in iron, from Karnataka's roots.",
    },
    {
      name: "Akkaravadisal",
      image:
        "https://i.pinimg.com/736x/97/04/98/9704986138f7c5876c410bb41547601e.jpg",
      description:
        "A traditional recipe, typically made and served as a temple offering in Tamil Nadu",
    },
  ],
  East: [
    {
      name: "Litti Chokha",
      image:
        "https://c.ndtvimg.com/r1m5m4n8_litti-chokha_625x300_24_August_18.jpg",
      description:
        "A special delicacy from Bihar, litti chokha is the perfect dish to represent the earthiness of the state.",
    },
    {
      name: "Machcher Jhol",
      image:
        "https://c.ndtvimg.com/2018-10/91mpfjs_fish-curry_625x300_16_October_18.jpg",
      description:
        "A household staple in every Bengali home, fish curry made in mustard oil.",
    },
    {
      name: "Rasgulla",
      image:
        "https://i.ndtvimg.com/i/2017-10/rasgulla-recipe_620x330_51508133855.jpg",
      description: "Roshogulla is a proud traditional Bengali dessert .",
    },
  ],
  West: [
    {
      name: "Vada pav",
      image:
        "https://cdn.tasteatlas.com//Images/Dishes/951728fa0ae74174a2602aaece17368c.jpg?w=905&h=510",
      description: "Vada pav is one of Mumbai's favorite sandwiches",
    },
    {
      name: "Pav bhaji",
      image:
        "https://cdn.tasteatlas.com//Images/Dishes/f77866f0f5474fc0b41d316f885edcc3.jpg?w=905&h=510",
      description:
        "Pav bhaji is a popular street snack originating from the Indian state of Maharashtra",
    },
    {
      name: "Shrikhand",
      image:
        "https://cdn.tasteatlas.com//Images/Dishes/b40366bbc02a4ad583c12a036f44e69a.jpg?w=905&h=510",
      description:
        "Shrikhand is a popular Indian yogurt-based dessert, combined with sugar and nuts",
    },
  ],
};

const AncientFoods = () => {
  return (
    <>
      <NavigationBar />
      <IndianFoodFilter />
      <Container className="py-5">
        <h1 className="text-center fw-bold mb-4">
          Ancient & Authentic Foods of Bharat 🇮🇳
        </h1>
        <p className="text-center text-muted mb-5">
          Rooted in Ayurveda, temples, tribes and time – discover the sacred
          flavours of India.
        </p>

        {Object.entries(ancientFoodData).map(([region, dishes]) => (
          <div key={region} className="mb-5">
            <h3 className="mb-4 fw-semibold text-success">{region}</h3>
            <Row>
              {dishes.map((dish, index) => (
                <Col md={6} lg={4} key={index} className="mb-4">
                  {/* // inside your map loop */}
                  <Card className="h-100 shadow-sm">
                    {/* Pass the entire dish object in Link state so the detail page can show image & description immediately */}
                    <Link
                      to={`/heritage/food/${encodeURIComponent(dish.name)}`}
                      state={{ dish }}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <Card.Img
                        variant="top"
                        src={dish.image}
                        alt={dish.name}
                        style={{ height: "250px", objectFit: "cover" }}
                      />
                      <Card.Body>
                        <Card.Title>{dish.name}</Card.Title>
                        <Card.Text>
                          {typeof dish.description === "string"
                            ? dish.description
                            : JSON.stringify(dish.description)}
                        </Card.Text>
                      </Card.Body>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Ad Block */}
            <div className="bg-light border rounded text-center p-3 mt-4">
              <strong>Ad:</strong> Learn ancient millet recipes from Bharatiya
              kitchens. Try a workshop!
            </div>
          </div>
        ))}
      </Container>
    </>
  );
};

export default AncientFoods;
